/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import MasterRateMatrix from "./MasterRateMatrix";
import MasterRateForm from "./MasterRateForm";
import RateComission from "../LeadGenerationCP/NewRateCard/RateComission";
import RateCharges from "./MasterRateSlab";
import {
  Form,
  message,
  Spin,
  Button,
  Input,
  Select,
  Row,
  Popconfirm,
  Checkbox,
} from "antd";
import API from "../../api";
import urls from "../../api/urls";
import { masterRateCardAPI, zoneAPI } from "../../api/RateCardApi";
import Heading from "../../components/Heading";
import useCustomNavigate from "../../components/customNavigationHook";
import { spaceBeforeCapital } from "../../utils";
import { useLocation } from "react-router-dom";
import RateCardMatrix from "../DynamicRateCard/DynamicRateCardMatrix";
import CloneRateCardTemplate from "./CloneRateCardTemplate";
import validateRateCard from "../DynamicRateCard/rateUtil";
import AssignRateCard from "./AssignRateCard";
const {
  GET_HUB_PINCODE,
  GET_RATE_CARD_QUOTATION,
  GET_ALL_CHARGES,
  GET_ALL_CALCULATION_BASIS,
} = urls;

const MasterRateCard = ({
  changeTab = () => {},
  updatesRateList = () => {},
}) => {
  const [quotationRateMatrixCash, setQuotationRateMatrixCash] = useState({});
  const [defaultRateCharge, setDefaultRateCharge] = useState([]);
  const [calculationBasisList, setCalculationBasisList] = useState([]);
  const [rateChargesData, setRateChargesData] = useState([]);
  const [rateChargeErr, setRateChargeErr] = useState([]);
  const [quotationRateCharges, setquotationRateCharge] = useState([]);
  const [rateMatrix, setRateMatrix] = useState({});
  const [templateDetails, setTemplateDetails] = useState({});
  const [rateCardError, setRateCardError] = useState([]);
  const param = useParams();
  const navigate = useCustomNavigate();
  const History = useLocation();
  const actionType = history?.state?.usr?.action;
  const [rateCardTypes, setRateCardTypes] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [assignRateDetails, setAssignRateDetails] = useState(null);
  const [submitScope, setSubmitScope] = useState(null);
  const [defaultZones, setDefaultZones] = useState([]);
  const [form] = Form.useForm();
  const [form1] = Form.useForm();
  const [loader, setLoader] = useState(false);
  const [addRateMatrix, setAddRateMatrix] = useState(false);
  useEffect(() => {
    fetchInitialData();
  }, []);

  useEffect(() => {
    if (param?.id) {
      getRateCardDetails();
    }
  }, []);

  const getRateCardDetails = async () => {
    let res = await masterRateCardAPI.getRateById(param?.id);
    const data = res?.response?.data || {};
    setAssignRateDetails(data);
    form.setFieldsValue({
      name: data?.name,
    });
    setquotationRateCharge(data?.charges);

    form1.setFieldsValue({
      commission: data?.commission,
      // slab: data?.commission?.[0]?.slab,
      // rateType: data?.commission?.[0]?.rateType,
    });
    if (
      data?.rates?.[0]?.rate &&
      Object.keys(data?.rates?.[0]?.rate).length > 0
    ) {
      setAddRateMatrix(true);
    } else {
      setAddRateMatrix(false);
    }
    setQuotationRateMatrixCash({ ...data?.rates?.[0]?.rate });
  };

  useEffect(() => {
    if (templateDetails?.commission?.length > 0) {
      form1.setFieldsValue({
        commission: templateDetails?.commission || [],
      });
    }

    if (
      templateDetails?.rates?.[0]?.rate &&
      Object.keys(templateDetails?.rates?.[0]?.rate).length > 0
    ) {
      setAddRateMatrix(true);
    } else {
      setAddRateMatrix(false);
    }
  }, [templateDetails]);
  const fetchInitialData = async () => {
    try {
      setLoader(true);

      const [chargeRes, calcRes] = await Promise.all([
        API.Api(GET_ALL_CHARGES).get(),
        API.Api(GET_ALL_CALCULATION_BASIS).get(),
      ]);

      if (chargeRes?.status) {
        setDefaultRateCharge(
          chargeRes.response.data.map(({ _id, head, calculationBasis }) => ({
            _id,
            head,
            key: _id,
            calculationBasis,
            global: true,
          }))
        );
      } else {
        message.error(
          chargeRes?.response?.data?.message || "Can't fetch rate charges."
        );
      }

      if (calcRes?.status) {
        setCalculationBasisList(
          calcRes.response?.data?.map((item) => ({
            label: spaceBeforeCapital(item?.name),
            value: item?.name,
            unit: item?.unit,
          }))
        );
      }
    } catch (error) {
      message.error("Failed to fetch initial data.");
    } finally {
      setLoader(false);
    }
  };

  const setRateCharge = (data) => {
    setRateChargesData(data);
  };

  const saveRateCard = async (val, type) => {
    try {
      let comission = form1.getFieldsValue();
      const result = validateCharges(rateChargesData);
      if (result.length > 0) {
        message.error(result);
        window.scrollTo({ top: 10, left: 0, behavior: "smooth" });
        return;
      }
      if (addRateMatrix) {
        const rateCardError = validateRateCard(rateMatrix, rateCardTypes);
        setRateCardError(rateCardError);
        if (rateCardError.length > 0) {
          message.error("Please fill the zero value in the matrix");
          return;
        }
      }

      let travelMode = rateCardTypes?.travelMode?.[0];
      let docType = rateCardTypes?.docType?.[0];
      let shippingType = rateCardTypes?.shippingType?.[0];
      const allZones = rateMatrix?.[docType]?.[travelMode]?.[shippingType]?.[0];
      const customZones = Object.keys(allZones || {}).filter(
        (key) => !defaultZones.includes(key)
      );
      let payloadRates = [];
      if (addRateMatrix) {
        payloadRates = [
          {
            rate: rateMatrix || {},
          },
        ];
      }
      const payload = {
        ...val,

        commission: comission?.commission,
        rates: payloadRates,
        charges: rateChargesData?.map((item) => ({
          chargesHead: item?.head,
          rateType: item?.chargeType,
          pricingType: item?.pricingType,
          appliesOn: item?.appliesOn,
          calculationBasis: item?.calculationBasis,
          rate:
            item?.pricingType === "SLAB" || item?.chargeType === "PERCENTAGE"
              ? null
              : parseFloat(item?.rate),
          slabId: item?.pricingType === "FIXED" ? null : item?.slabId,
          percentage:
            item?.pricingType === "SLAB" || item?.chargeType === "VALUE"
              ? null
              : parseFloat(item?.percentage),
        })),
      };

      setLoader(true);
      let res;
      if (param?.id) {
        res = await masterRateCardAPI.patchRate(param?.id, payload);
      } else {
        res = await masterRateCardAPI.createRate(payload);
      }

      if (res?.status) {
        setLoader(false);
        if (param?.id) {
          if (customZones.length > 0 && addRateMatrix) {
            const payload = {
              zones: customZones,
              rateCardId: param?.id,
            };
            const headers = {
              parent: localStorage.getItem("userinfo")?.roles?.includes("CP")
                ? "CP"
                : "HO",
            };
            const resZone = await zoneAPI.patchZoneRateCard(payload, headers);
            if (!resZone?.status) {
              message.error(
                resZone?.response?.data?.message || "Internal server error."
              );
            }
          }
          if (type) {
            const cloneRes = await masterRateCardAPI.cloneRateCard({
              refId: param?.id,
            });
            if (cloneRes?.status) {
              message.success("Updated successfully");
            } else {
              message.error(
                cloneRes?.response?.data?.message || "Internal server error"
              );
            }
          }
          navigate("/default-ratecard", { state: "2" });
        } else {
          if (customZones.length > 0 && addRateMatrix) {
            const payload = {
              zones: customZones,
              rateCardId: res?.response?.data?._id,
            };
            const headers = {
              parent: localStorage.getItem("userinfo")?.roles?.includes("CP")
                ? "CP"
                : "HO",
            };
            const resZone = await zoneAPI.patchZoneRateCard(payload, headers);
            if (!resZone?.status) {
              message.error(
                resZone?.response?.data?.message || "Internal server error."
              );
            }
          }
          updatesRateList();
          navigate("/default-ratecard", { state: "2" });
        }
      } else {
        setLoader(false);
        let msg = "";

        if (res?.response?.data?.errors?.length > 0) {
          res?.response?.data?.errors?.map((e) => {
            msg += e;
          });
        } else {
          msg += res?.response?.data?.message;
        }
        message.error(msg || "Internal server error.");
      }
    } catch (errorInfo) {
      console.log(errorInfo);
      window.scrollTo({ top: 10, left: 0, behavior: "smooth" });
    }
  };

  const validateCharges = (charges) => {
    const errors = [];

    charges.forEach((charge) => {
      const {
        chargeType,
        appliesOn,
        pricingType,
        activeType,
        rate,
        percentage,
        slabId,
      } = charge;

      if (!appliesOn || !pricingType) {
        //errors.push(`Missing required fields in head: ${charge.head}`);
        errors.push(charge.head);
      }

      if (activeType === "rate" && !rate) {
        errors.push(charge.head);
        // errors.push(
        //   `Rate is missing for activeType "rate" in head: ${charge.head}`
        // );
      } else if (activeType === "percentage" && !percentage) {
        errors.push(charge.head);
        // errors.push(
        //   `Percentage is missing for activeType "percentage" in head: ${charge.head}`
        // );
      } else if (activeType === "slabId" && !slabId) {
        errors.push(charge.head);
        // errors.push(
        //   `Slab ID is missing for activeType "slabId" in head: ${charge.head}`
        // );
      }
    });
    setRateChargeErr(errors);
    if (errors.length > 0) {
      return `Please fill values of ${errors}`;
    }

    return errors;
  };

  return (
    <>
      {param?.id && (
        <div className="p-05">
          <Heading
            title={`${actionType === "EDIT" ? "Edit" : "View"} Rate Card`}
            id={"2"}
            navigateTo={"/default-ratecard"}
            extraContent={
              actionType === "VIEW" && (
                <Button
                  type="primary"
                  className="save-btn"
                  onClick={() => {
                    setIsModalOpen(true);
                  }}
                >
                  Assign Template
                </Button>
              )
            }
          />
        </div>
      )}
      <div className="master-main-container">
        <Spin spinning={loader}>
          <Form
            className="global-form"
            layout="vertical"
            form={form}
            scrollToFirstError={{
              behavior: "smooth",
              block: "center",
              inline: "center",
            }}
            onFinish={(values) => saveRateCard(values, submitScope)}
            onFinishFailed={(errorInfo) => {
              console.log(errorInfo, "erro");
            }}
          >
            <MasterRateForm
              disable={actionType === "VIEW"}
              getTemplateDetails={(data) => setTemplateDetails(data)}
              hideCloneTemplate={actionType === "VIEW"}
            />

            <RateComission
              formName={form1}
              defaultRateCharge={defaultRateCharge}
              disable={actionType === "VIEW"}
            />

            <RateCharges
              rateCharge={setRateCharge}
              quotationRateCharge={
                templateDetails?.charges || quotationRateCharges
              }
              defaultRateCharge={defaultRateCharge}
              //stateCode={stateCode}
              errors={rateChargeErr}
              setError={() => setRateChargeErr([])}
              calculationBasisList={calculationBasisList}
              disable={actionType === "VIEW"}
            />
            <div className="d-flex ml-2 mt-2">
              <Checkbox
                onChange={(e) => setAddRateMatrix(e.target.checked)}
                className="custom-checkbox-add-rate-matrix"
                checked={addRateMatrix}
                disabled={actionType === "VIEW"}
              >
                <span className="f-18 fw-500">Add RateMatrix</span>
              </Checkbox>
            </div>
            {addRateMatrix && (
              <RateCardMatrix
                getData={
                  templateDetails?.rates?.[0]?.rate || quotationRateMatrixCash
                }
                setMatrixData={(data) => setRateMatrix(data)}
                actionEdit={actionType === "VIEW" ? false : true}
                notCloneZone={true}
                setRateCardOptionTypes={(data) => setRateCardTypes(data)}
                rateCardError={rateCardError}
                getAllDefaultZones={(data) => setDefaultZones(data)}
                rateCardId={param?.id}
              />
            )}
            {/* <MasterRateMatrix
              rateMatrixData={setRateMatric}
              quotationRateMatrix={quotationRateMatrixCash}
              templateType={actionType === "VIEW" ? "view" : "create"}
            /> */}
            {actionType !== "VIEW" && (
              <div className="flex-end p-1">
                {param?.id ? (
                  <Popconfirm
                    title="Do you want to update rates for all ratecards created from this template?"
                    okText="Yes"
                    cancelText="No"
                    //onOk={(val) => saveRateCard(val, "yes")}
                    onCancel={() => {
                      setSubmitScope(false);
                      form.submit();
                    }}
                    onConfirm={() => {
                      setSubmitScope(true);
                      form.submit();
                    }}
                  >
                    <Button className="save-btn">UPDATE</Button>
                  </Popconfirm>
                ) : (
                  <Button className="save-btn" htmlType="submit">
                    SAVE
                  </Button>
                )}
              </div>
            )}
          </Form>
        </Spin>
        <AssignRateCard
          isModalOpen={isModalOpen}
          setIsModalOpen={setIsModalOpen}
          assignRateDetails={assignRateDetails}
        />
      </div>
    </>
  );
};
export default MasterRateCard;
